export const environment = {
  production: true,
  Api_Base_Url: "https://api.procric8.com/api/",
  Java_Api_User_Base_Url: "https://procric8.com/user-service/api/",
  Java_Api_Admin_Base_Url: "https://procric8.com/admin-service/api/",
  Image_Base_Url: "http://api.procric8.com",
  CallbackUrl: "http://user.procric8.com/#/payment/register",
};
